// IE Support
export function createNewEvent(eventName) {
  if (typeof(Event) === 'function') {
    var e = new Event(eventName)
  } else {
    var e = document.createEvent('Event')
    e.initEvent(eventName, true, true)
  }
  return e
}